import { Component } from '@angular/core';
import { LoginService } from '@shared-angular/services/login.service';

@Component({
  template: ''
})
export class LoginComponent {
  constructor(public loginService: LoginService) { }
}